export default __webpack_public_path__ + "static/janson@2x-13916f9c7416bdb8f72131a1ffae9236.jpg";